
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import Themeable from 'vuetify/lib/mixins/themeable';
import { TicketInterface } from '@/services/QC-V2/ticket/interfaces';
import { DataTableHeader } from 'vuetify';

interface DataTableOptions {
  page: number,
  itemsPerPage: number,
  sortBy: string[],
  sortDesc: boolean[],
  groupBy: string[],
  groupDesc: boolean[],
  multiSort: boolean,
  mustSort: boolean
}

@Component({
  mixins: [
    Themeable,
  ],
})
export default class TicketsTable extends Vue {
  @Prop() private tickets!: TicketInterface[];
  @Prop({ default: 0 }) private totalItems!: number;
  @Prop({ default: () => [] }) private disabledTickets!: { [key: number]: string[] };
  @Prop({ default: 1 }) private page!: number;

  private loading: boolean = false;
  private options: DataTableOptions = {
    itemsPerPage: 10,
    page: this.page,
  } as DataTableOptions;

  private selectedTicketId: number = 0;
  private headers: DataTableHeader[] = [
    { text: 'Requester', value: 'requester', sortable: false },
    { text: 'Subject', value: 'subject', sortable: false },
  ];

  @Watch('page')
  private handlePageUpdate(): void {
    this.options.page = this.page;
  }

  @Watch('options', { deep: true })
  private handlePageChange(): void {
    this.$emit('change-page', this.options.page);
  }

  private getTicket(id: number): void {
    if (this.disabledTickets[id]) {
      this.$errorDialog.show(`There are some missing agents
      (${this.disabledTickets[id].join(', ')})... register them to review ticket.`);

      return;
    }
    this.selectedTicketId = id;
    this.$emit('get-ticket', id);
  }

  private getAvatar(name: string): string {
    const nameArr = name.split(' ');
    return `https://ui-avatars.com/api/?name=${nameArr.join('+')}&background=random&&length=${nameArr.length}`;
  }
}
